<template>
  <article class="card card-link mw-520 mx-auto">

    <!-- TODO: Comment in if add to favorite neeeds to be used! -->
    <!-- <button
      type="button"
      :class="[
        'btn add-favorite',
        { 'in-list': addedDocuments.includes(card.id) },
      ]"
      title="Tilføj til ønskeliste"
      :data-favoriteid="card.id"
      data-bs-toggle="modal"
      data-bs-target="#userModal"
      @click="showWishlistModal"
    ></button> -->
    <div class="ratio ratio-1x1">
      <v-lazy-image
        v-if="card.imageTeaserBox && card.imageTeaserBoxMobile"
        class="img-fit"
        :srcset="`${card.imageTeaserBox} 380w, ${card.imageTeaserBoxMobile} 520w`"
        sizes="(min-width: 768px) 380px, 520px"
        src="/public/img/placeholder.gif?mode=crop&width=520&height=520"
        :alt="card.imageAltText"
        use-picture
      ></v-lazy-image>
      <picture v-else>
        <img
          class="img-fit"
          src="/public/img/placeholder.gif?mode=crop&width=520&height=520"
          alt="placeholder image"
        />
      </picture>
    </div>
    <div class="card-body">
      <p class="fs-7 text-uppercase mb-1">{{ card.category }}</p>
      <a :href="card.url" class="stretched-link h3">{{ card.title }}</a>
    </div>
  </article>
</template>

<script>
import { defineCustomElement } from "vue";
import VLazyImage from "v-lazy-image";
const MyVueElement = defineCustomElement({
  // normal Vue component options here
  props: {},
  emits: {},
  template: `<v-lazy-image
          class="img-fit"
          
          sizes="(min-width: 768px) 380px, 520px"
          src="/public/img/placeholder.gif?mode=crop&width=520&height=520"
          :alt="card.ImageAltText"
          use-picture
        >
        <source :srcset="card.imageTeaserBox + '&format=webp&quality=70 380w, ' + card.imageTeaserBox + ' 380w, '+ card.imageTeaserBoxMobile + '&format=webp&quality=70 520w, ' + card.imageTeaserBoxMobile + ' 520w" />
        </v-lazy-image>`,

  // defineCustomElement only: CSS to be injected into shadow root
  styles: [`/* inlined css */`],
});

export default {
  name: "BlogBoxViewCard",
  props: ["card"],
  components: {
    VLazyImage,
  },
  computed: {
    addedDocuments() {
      return this.$store.state.addedDocuments
        ? this.$store.state.addedDocuments
        : [];
    },
  },
  methods: {
    showWishlistModal: function (event) {
      const favoriteId = document.getElementById("favoriteId");
      favoriteId.value = this.card.id;
      var change = new Event("change");
      favoriteId.dispatchEvent(change);
    },
  },
};
</script>
